/// <reference path="../../../Data/DataObjects/DataColumnListEditor.ts" />

namespace Matrix.Dashboards {

    @Serenity.Decorators.registerEditor('Matrix.Dashboards.TableColumnListEditor')
    export class TableColumnListEditor extends Data.DataColumnListEditor {
        protected getDialogType() { return TableColumnDialog; }
    }
}